module.exports = __webpack_public_path__ + "static/media/rss.e224533e.svg";